import React, { useState, useEffect } from "react";
import { MDBContainer } from "mdbreact";

import "./styles.css";

import Banner from "../../../template/Banner";
import NewsCard from "../../../template/NewsCard";
import Loader from "../../../template/Loader";
import Pagination from "../../../template/Pagination";

import api from "../../../../services/api";

import bannerImg from "../../../../assets/img/acoes/banner.jpg";

export default () => {
  const [data, setData] = useState(null);
  const [actionsData, setActionsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);

  const description = "Numquam aliquam quae vitae saepe! Harum deleniti";

  useEffect(() => {
    (async function fetchActionsData() {
      setLoading(true);

      try {
        const { data } = await api.get(
          `/posts?pagesize=5&category=4&page=${page}`
        );

        if (data.success) {
          setData(data);
          setActionsData(data.posts);
        }
      } catch (error) {
        console.error(error.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [page]);

  return (
    <div className="actions">
      <Banner img={bannerImg} title="AÇÕES" subtitle={description} />

      <MDBContainer>
        <div className="content">
          <h1>Lorem ipsum dolor sit amet consectetur adipisicing elit</h1>
          <p>
            Cumque, consequatur! Quibusdam temporibus dolor deleniti, molestias
            fugiat ullam, quia doloribus ab harum error repellendus voluptas
            architecto suscipit facilis explicabo, vero soluta. Lorem ipsum
            dolor sit amet consectetur, adipisicing elit.
          </p>
        </div>

        <div className="my-5">
          {loading ? (
            <Loader />
          ) : (
            <div className="my-5">
              {actionsData.map((item) => (
                <NewsCard
                  key={item.id}
                  img={item.image_url}
                  date={item.date}
                  author={item.author}
                  title={item.title}
                  subtitle={item.description}
                  path={`/nossa-atuacao/acoes/${item.slug}`}
                />
              ))}

              {data && data.total_page > 1 && (
                <Pagination
                  setPage={setPage}
                  page={page}
                  totalPage={data.total_page}
                />
              )}
            </div>
          )}
        </div>
      </MDBContainer>
    </div>
  );
};
